// Mock data for Rahul Pareek's Portfolio

export const personalInfo = {
  name: "Rahul Pareek",
  title: "Full Stack Java Developer",
  subtitle: "Learning & Building | BCA Student | Regex Software Services",
  location: "India",
  email: "itsrahul615@gmail.com",
  phone: "+91 935230****",
  linkedin: "https://linkedin.com/in/rahulpareek26062007",
  github: "https://github.com/rahulpareek011",
  resume: "/resume.pdf"
};

export const aboutInfo = {
  description: "Passionate Full Stack Java Developer currently gaining hands-on experience at Regex Software Services. I'm pursuing my BCA degree from MGSU University while actively learning modern web technologies and enterprise Java development.",
  education: [
    {
      degree: "Bachelor of Computer Applications (BCA)",
      institution: "MGSU University",
      duration: "2023 - Present",
      status: "Pursuing"
    }
  ],
  experience: [
    {
      position: "Java Development Trainee",
      company: "Regex Software Services",
      duration: "14 April 2025 - Present",
      description: "Gaining hands-on experience in Full Stack Java Development, working with Spring Boot, React, and database technologies."
    }
  ],
  skills: [
    { category: "Backend", items: ["Java", "Spring Boot", "Spring MVC", "Hibernate", "MySQL", "PostgreSQL"] },
    { category: "Frontend", items: ["React.js", "JavaScript", "HTML5", "CSS3", "Bootstrap", "Tailwind CSS"] },
    { category: "Tools & Technologies", items: ["Git", "Maven", "Eclipse", "VS Code", "Postman", "Docker"] },
    { category: "Currently Learning", items: ["Microservices", "AWS", "MongoDB", "Next.js"] }
  ]
};

export const projects = [
  {
    id: 1,
    title: "Big Projects Coming Soon",
    description: "Full-stack e-commerce platform built with Spring Boot and React. Features include user authentication, product catalog, shopping cart, and order management.",
    technologies: ["Spring Boot", "React.js", "MySQL", "Spring Security", "Bootstrap"],
    image: "https://images.unsplash.com/photo-1556742049-0cfed4f6a45d?w=800&h=600&fit=crop",
    demoUrl: "https://demo-ecommerce.example.com",
    githubUrl: "https://github.com/rahulpareek/ecommerce-app",
    status: "Completed"
  },
  {
    id: 2,
    title: "Big Projects coming soon",
    description: "A collaborative task management application with real-time updates. Built using Spring Boot REST API and React frontend with state management.",
    technologies: ["Spring Boot", "React.js", "WebSocket", "PostgreSQL", "Redux"],
    image: "https://images.unsplash.com/photo-1611224923853-80b023f02d71?w=800&h=600&fit=crop",
    demoUrl: "https://task-manager.example.com",
    githubUrl: "https://github.com/rahulpareek/task-manager",
    status: "In Progress"
  },
  {
    id: 3,
    title: "Big Projects coming soon",
    description: "Academic management system for students and faculty. Features include course enrollment, grade tracking, and assignment submission.",
    technologies: ["Spring MVC", "JSP", "MySQL", "Apache Tomcat", "CSS3"],
    image: "https://images.unsplash.com/photo-1434030216411-0b793f4b4173?w=800&h=600&fit=crop",
    demoUrl: "https://student-portal.example.com",
    githubUrl: "https://github.com/rahulpareek/student-portal",
    status: "Completed"
  },
  {
    id: 4,
    title: "Big Projects coming soon",
    description: "RESTful API for banking operations with secure authentication and transaction management. Implements best practices for financial applications.",
    technologies: ["Spring Boot", "Spring Security", "JWT", "MySQL", "Maven"],
    image: "https://images.unsplash.com/photo-1556742049-0cfed4f6a45d?w=800&h=600&fit=crop",
    demoUrl: null,
    githubUrl: "https://github.com/rahulpareek/banking-api",
    status: "Completed"
  }
];

export const contactInfo = {
  email: "rahul.pareek@example.com",
  phone: "+91 935230****",
  location: "India",
  linkedin: "https://linkedin.com/in/rahulpareek011",
  github: "https://github.com/rahulpareek26062007",
  availability: "Open to internship and entry-level opportunities"
};